import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { useRoute } from '@react-navigation/native';
import {
  Dimensions,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  View,
  Switch,
  TouchableWithoutFeedback /*TouchableWithoutFeedback**/,
  FlatList,
} from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { /*faDollarSign,**/ faCaretDown as faMore, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { BText, Drawer, Page } from '../../../components';
import { Button, ButtonContainer, FormContainer, Input, InputRefProps } from '../../../components/Form';
import eventListingJson from '../../../assets/data/eventListing.json';
import eventCateJson from '../../../assets/data/eventCategory.json';
import eventTypeJson from '../../../assets/data/eventType.json';
import { MasterCityModel, MasterStateModel, TaskModel, TaskInputSchema } from '../../../types';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { setLoading } from '../../../store/portal/portalActions';
import getService from '../../../services/geoService';
import { themeConfig } from '../../../styles/themeConfig';
import { breakpointWidth } from '../../../utils/helper';
import { themeHeader, theme } from '../../../styles';
// import eventService from '../../../services/eventService';
import taskService from '../../../services/taskService';
// import CalendarView from './CalendarView';
// import MapComponent from '../../../components/MapComponent';

export const AdminEventDetailsManagement = ({ navigation }: any) => {
  const route = useRoute();
  const dispatch = useAppDispatch();

  const [events] = useState(eventListingJson);
  const [eventCates, setEventCates] = useState<any>();
  const [eventTypes, setEventTypes] = useState<any>();

  const { eventId } = route.params as { eventId?: string };
  const [selectedEvent, setSelectedEvent] = useState<any>(eventId);
  const [selectedCate, setSelectedCate] = useState<string>('');
  const [selectedType, setSelectedType] = useState<string>('');
  const [selectedState, setSelectedState] = useState<string>('');
  const [states, setStates] = useState<MasterStateModel>();
  const [cities, setCities] = useState<MasterCityModel>();

  const [isReadOnly, setReadOnly] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean | number>(false);
  const [isOnlineEvent, setOnlineEvent] = useState(false);
  const [withTimeSlot, setTimeSlot] = useState(false);
  const [showPublish, setShowPublish] = useState(false);
  const [showCalendar, setShowCalendar] = useState<boolean>(false);

  const inputName = useRef<InputRefProps>(null);
  const inputDescription = useRef<InputRefProps>(null);
  const inputStartDate = useRef<InputRefProps>(null);
  const inputEndDate = useRef<InputRefProps>(null);
  const inputStartTime = useRef<InputRefProps>(null);
  const inputEndTime = useRef<InputRefProps>(null);
  const inputTicketPrice = useRef<InputRefProps>(null);
  const inputTotalTicket = useRef<InputRefProps>(null);
  const inputTotalTicketSold = useRef<InputRefProps>(null);
  const inputCategory = useRef<InputRefProps>(null);
  const inputAddress = useRef<InputRefProps>(null);
  const inputState = useRef<InputRefProps>(null);
  const inputCity = useRef<InputRefProps>(null);
  const inputOnlinEventLink = useRef<InputRefProps>(null);
  const inputTnc = useRef<InputRefProps>(null);
  const inputPolicy = useRef<InputRefProps>(null);
  const inputScheduleDate = useRef<InputRefProps>(null);
  const inputScheduleTime = useRef<InputRefProps>(null);

  const windowWidth = Dimensions.get('window').width;
  const [rtPortal] = useAppSelector(s => [s.portal]);
  type MenuItemType = {
    label?: string;
    type?: string;
  };

  const toggleSwitch = () => setOnlineEvent(previousState => !previousState);
  const toggleSwitchTimeSlot = () => setTimeSlot(previousState => !previousState);

  const handleMenuToggle = () => {
    let newStatus = !isOpen;
    setIsOpen(newStatus);
  };

  const handleMenuItemPress = (item: MenuItemType) => {
    setIsOpen(false);

    if (item.label === 'Publish') setShowPublish(true);
    else setShowCalendar(true);
  };

  const menuItems: MenuItemType[] = [{ label: 'Publish' }, { type: 'divider' }, { label: 'Schedule Publish' }];

  useEffect(() => {
    dispatch(setLoading(true));
    getService.getStates().then(res => {
      dispatch(setLoading(false));
      setStates(
        res.data
          .map((row: any) => {
            row.value = row.code;
            row.label = row.state;
            return row;
          })
          .sort((a: any, b: any) => a.label.localeCompare(b.label)),
      );
    });
  }, []);

  useEffect(() => {
    if (selectedState) {
      dispatch(setLoading(true));
      getService.getCityByState(selectedState).then(res => {
        dispatch(setLoading(false));
        setCities(
          res.data
            .map((label: string) => {
              let row = {
                value: label,
                label: label,
              };

              return row;
            })
            .sort((a: any, b: any) => a.label.localeCompare(b.label)),
        );
      });
    }
  }, [selectedState]);

  useEffect(() => {
    events.map(event => {
      if (event._id === selectedEvent) {
        setSelectedEvent(event);

        if (event.status === 'Active' || event.status === 'Ended') setReadOnly(true);
        else setReadOnly(false);

        if (event.onlineEvent === 1) setOnlineEvent(true);
        else setOnlineEvent(false);
        if (event.onlineEvent === 1) setTimeSlot(true);
        else setTimeSlot(false);
      }

      return null;
    });
  }, [eventId]);

  useEffect(() => {
    updateInputValue(inputName.current, selectedEvent?.eventName || '');
    updateInputValue(inputDescription.current, selectedEvent?.eventDescription || '');
    updateInputValue(inputStartDate.current, moment(selectedEvent?.eventDate?.start).format('YYYY-MM-DD'));
    updateInputValue(inputEndDate.current, moment(selectedEvent?.eventDate?.end).format('YYYY-MM-DD'));
    updateInputValue(inputStartTime.current, moment(selectedEvent?.eventDate?.start).format('HH:mm'));
    updateInputValue(inputEndTime.current, moment(selectedEvent?.eventDate?.end).format('HH:mm'));
    updateInputValue(inputTicketPrice.current, selectedEvent?.eventPrice || '0');
    updateInputValue(inputTotalTicket.current, selectedEvent?.numberOfTickets || '0');
    updateInputValue(inputTotalTicketSold.current, selectedEvent?.numberOfTicketsSold || '0');
    updateInputValue(inputAddress.current, selectedEvent?.address || '');
    updateInputValue(inputOnlinEventLink.current, selectedEvent?.onlineEventLink || '');
    updateInputValue(inputTnc.current, selectedEvent?.termsAndConditions || '');
    updateInputValue(inputPolicy.current, selectedEvent?.policy || '');
    updateInputValue(inputScheduleDate.current, selectedEvent?.scheduledDate || '');
    updateInputValue(inputScheduleTime.current, selectedEvent?.scheduledDate || '');
    // updateInputValue(inputCategory.current, selectedEvent?.eventCategory?.name || '')
    setSelectedCate(selectedEvent?.eventCategory?.name || '');
    setSelectedType(selectedEvent?.eventType?.name || '');
    if (selectedEvent !== undefined) {
      dispatch(setLoading(false));
      setSelectedState(selectedEvent?.state || '');
    }
  }, [selectedEvent]);

  useEffect(() => {
    // if (selectedCate) {
    setEventCates(
      eventCateJson.map((row: any) => {
        row.value = row.id;
        row.label = row.category;
        return row;
      }),
    );
    // }
  }, [selectedCate]);

  useEffect(() => {
    // if (selectedCate) {
    setEventTypes(
      eventTypeJson.map((row: any) => {
        row.value = row.id;
        row.label = row.type;
        return row;
      }),
    );
    // }
  }, [selectedType]);

  const updateInputValue = (element: InputRefProps | null, value: string) => {
    if (element) element.setValue(value);
  };

  const goBack = () => {
    navigation.goBack();
  };

  // const handleDateSelected = (selectedDate: Date) => {
  //   setSelectedDate(selectedDate);
  // };

  // const handleSave = (date: Date) => {
  //   setSelectedDate(date);
  //   setShowCalendar(false);
  //   setShowPublish(true)
  // };

  // const handleCancel = () => {
  //   setShowCalendar(false);
  // };

  const handlePublish = () => {
    setShowPublish(true);
    setTimeout(() => {
      navigation.goBack();
    }, 300);
  };

  const [data, setData] = useState([
    {
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      startTime: moment(new Date()).format('YYYY-MM-DD HH:mm'),
      endTime: moment(new Date()).format('YYYY-MM-DD HH:mm'),
      quantity: 0,
      occupied: 0,
    },
  ]);

  const addItem = () => {
    setData([...data,
      {
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
        startTime: moment(new Date()).format('YYYY-MM-DD HH:mm'),
        endTime: moment(new Date()).format('YYYY-MM-DD HH:mm'),
        quantity: 0,
        occupied: 0,
      },
    ]);
    console.log(data);
  };

  const removeItem = (index: number) => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  const updateStartDate = (startDate: string, index: number) => {
    const newData = [...data];
    newData[index].startDate = startDate;
    setData(newData);
  };

  const updateEndDate = (endDate: string, index: number) => {
    const newData = [...data];
    newData[index].endDate = endDate;
    setData(newData);
  };

  const updateStartTime = (startTime: string, index: number) => {
    const newData = [...data];
    newData[index].startTime = startTime;
    setData(newData);
  };
  
  const updateEndTime = (endTime: string, index: number) => {
    const newData = [...data];
    newData[index].endTime = endTime;
    setData(newData);
  };

  const renderItem = ({ item, index } : {item: any, index: any}) => {
    if (index === 0) {
      return (
        <View style={styles.eventDateTimeContainer}>
                <View style={styles.eventDateContainer}>
                  <Input
                    label={'Start Date'}
                    id="startDate"
                    type="date"
                    onChange={(startDate: any) => updateStartDate(startDate, index)}
                    value={moment(item.startDate).format('YYYY-MM-DD')}
                    schemaContext={{ isEdit: true }}
                    // ref={inputStartDate}
                  />
                  <Input
                    label={'End Date'}
                    id="endDate"
                    type="date"
                    onChange={(endDate: any) => updateEndDate(endDate, index)}
                    value={moment(item.endDate).format('YYYY-MM-DD')}
                    schemaContext={{ isEdit: true }}
                    // ref={inputEndDate}
                  />
                </View>
                <View style={{ padding: 10 }}/>
                <View style={styles.eventDateContainer}>
                  <Input
                    label={'Start Time'}
                    id="startTime"
                    type="time"
                    onChange={(startTime: any) => updateStartTime(startTime, index)}
                    value={moment(item.startTime).format('HH:mm')}
                    schemaContext={{ isEdit: true }}
                    // ref={inputStartTime}
                  />
                  <Input
                    label={'End Time'}
                    id="endTime"
                    type="time"
                    onChange={(endTime: any) => updateEndTime(endTime, index)}
                    value={moment(item.endTime).format('HH:mm')}
                    schemaContext={{ isEdit: true }}
                    // ref={inputEndTime}
                  />
                </View>
                <ButtonContainer direction="horizontal">
                  <Button onPress={addItem} buttonStyle={styles.buttonIcon}><FontAwesomeIcon icon={faPlus} size="1x" color="white" style={{ paddingRight: 5 }} /></Button>
                </ButtonContainer>
              </View>
      );
    } else {
      return (
      <View style={styles.eventDateTimeContainer}>
                <View style={styles.eventDateContainer}>
                  <Input
                    label={'Start Date'}
                    type="date"
                    onChange={(startDate: any) => updateStartDate(startDate, index)}
                    value={moment(item.startDate).format('YYYY-MM-DD')}
                    schemaContext={{ isEdit: true }}
                    // ref={inputStartDate}
                  />
                  <Input
                    label={'End Date'}
                    type="date"
                    onChange={(endDate: any) => updateEndDate(endDate, index)}
                    value={moment(item.endDate).format('YYYY-MM-DD')}
                    schemaContext={{ isEdit: true }}
                    // ref={inputEndDate}
                  />
                </View>
                <View style={{ padding: 10 }} />
                <View style={styles.eventDateContainer}>
                  <Input
                    label={'Start Time'}
                    type="time"
                    onChange={(startTime: any) => updateStartTime(startTime, index)}
                    value={moment(item.startTime).format('HH:mm')}
                    schemaContext={{ isEdit: true }}
                    // ref={inputStartTime}
                  />
                  <Input
                    label={'End Time'}
                    type="time"
                    onChange={(endTime: any) => updateEndTime(endTime, index)}
                    value={moment(item.endTime).format('HH:mm')}
                    schemaContext={{ isEdit: true }}
                    // ref={inputEndTime}
                  />
                </View>
                <ButtonContainer direction="horizontal">
                  <Button onPress={() => removeItem(index)} buttonStyle={styles.buttonIcon}><FontAwesomeIcon icon={faTimes} size="1x" color="white" style={{ paddingRight: 5 }} /></Button>
                </ButtonContainer>
              </View>
      );
    }
  };

  const saveEvent = async () => {
    let flatlistInput = data.map(item => item);
    let withTimeSlotValue;
    const newtimeSlots = flatlistInput.map(item => ({
      startDateTime: item.startTime.length > 5 ? moment(new Date(item.startDate + ' ' + moment(item.startTime).format('HH:mm'))).toISOString() : moment(new Date(item.startDate + ' ' + item.startTime)).toISOString(),
      endDateTime: item.endTime.length > 5 ? moment(new Date(item.endDate + ' ' + moment(item.endTime).format('HH:mm'))).toISOString() : moment(new Date(item.endDate + ' ' + item.endTime)).toISOString(),
      quantity: 0,
      occupied: 0,
    }));
    withTimeSlotValue = withTimeSlot.valueOf() === false ? 2 : 1;

    let event: TaskModel = {
      title: inputName.current?.value || '',
      description: inputDescription.current?.value || '',
      location: {
        city: inputCity.current?.value || '',
        state: inputState.current?.value || '',
        address: inputAddress.current?.value || '',
        unit: '1',
        latitude: 1,
        longitude: 1,
      },
      recurrence: false,
      taskDateTime: String(new Date()),
      timeSlots: newtimeSlots,
      remarks: inputCategory.current?.value || '',
      type: withTimeSlotValue,
    };
    
    TaskInputSchema.validate(event, { abortEarly: false, context: { isNew: true } })
      .then(async (obj: any) => {
        let res = await taskService.createTask(obj);
        if (res.data.resultCode === 0 || res.data.resultCode === 1) {
          dispatch(setLoading(false));
        } else {
          dispatch(setLoading(false));
        }
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  // const getStatusBgColor = (status: string) => {
  //   let color;
  //   if (status === 'Active') color = '#64FFBE';
  //   else if (status === 'Draft') color = '#FFF164';
  //   else if (status === 'Ended') color = '#FF6464';
  //   else color = 'white';
  //   return color;
  // };

  return (
    <View style={{ flex: 1, backgroundColor: themeConfig.colors.background, position: 'relative' }}>
      <BText
        style={{
          fontSize: 25,
          fontWeight: 'bold',
          padding: 20,
          backgroundColor: 'rgba(174, 174, 178, 0.8)',
        }}
      >
        {eventId !== '0' ? selectedEvent.eventName : 'Event Details'}
      </BText>
      <ButtonContainer direction="horizontal" containerStyle={styles.stickyFooter}>
        <TouchableOpacity onPress={handleMenuToggle}>
          <View
            style={{
              height: 30,
              flexDirection: 'row',
              backgroundColor: 'black',
              alignItems: 'center',
              borderRadius: 15,
              // alignSelf: 'baseline',
              alignContent: 'center',
              padding: 10,
            }}
          >
            <BText style={{ fontSize: 14, color: 'white', fontWeight: 'bold', paddingEnd: 15 }}>Publish</BText>
            <FontAwesomeIcon icon={faMore} size="1x" color="white" style={{ paddingRight: 5 }} />
          </View>
        </TouchableOpacity>

        {isOpen && (
          <View style={themeHeader.dropdown.menuList}>
            {menuItems.map((item, idx) => (
              <TouchableOpacity
                key={idx}
                onPress={() => handleMenuItemPress(item)}
                style={themeHeader.dropdown.menuItem}
                activeOpacity={0.7}
              >
                {item?.type === 'divider' && <View style={themeHeader.dropdown.menuDivider} />}
                {item.type === undefined && <BText>{item.label}</BText>}
              </TouchableOpacity>
            ))}
          </View>
        )}

        <Button onPress={() => saveEvent()}>Save</Button>
        <Button onPress={() => goBack()}>Cancel</Button>
      </ButtonContainer>

      {/* <TouchableOpacity style={ styles.squareContainer } >
        <FontAwesomeIcon icon={faDollarSign} size="1x" color='white' style={{paddingRight: 15}} />
        <View style={{ flexDirection: 'column'}}>
          <BText style={ styles.squareTitle }>Ticket Price</BText>
          <BText style={ styles.squareText }>RM {selectedEvent.eventPrice}</BText>
        </View>
      </TouchableOpacity> */}

      <Page
        title={''}
        contentStyle={[
          rtPortal.isSmallScreen
            ? { height: rtPortal.height - themeConfig.settings.mobileContentOffsetWithoutPageTitle, paddingBottom: 36 }
            : null,
        ]}
      >
        <ScrollView>
          <View
            style={[
              styles.verticalFlex,
              rtPortal.isSmallScreen
                ? { width: '100%', flexDirection: 'column' }
                : { width: breakpointWidth(rtPortal.breakpoint) },
            ]}
          >
            <FormContainer width={windowWidth} title="Event">
              <Input
                label={'Event Name'}
                id="eventName"
                value={selectedEvent?.eventName}
                // schemaObject={UserInputSchema}
                schemaContext={{ isEdit: true }}
                // readOnly={true}
                ref={inputName}
              />
              <Input
                label={'Event Description'}
                id="eventDescription"
                value={selectedEvent?.eventDescription}
                // schemaObject={UserInputSchema}
                schemaContext={{ isEdit: true }}
                ref={inputDescription}
              />
              <Input
                label={'Event Status'}
                id="eventDescription"
                value={selectedEvent?.status ? selectedEvent.status : 'Draft'}
                // schemaObject={UserInputSchema}
                schemaContext={{ isEdit: false }}
                readOnly={true}
                //   ref={inputDescription}
              />
              {/* <View style={{ flexDirection: 'row', paddingTop: 15, }} >
                    <BText
                        style={{
                            fontSize: 15,
                            fontWeight: 'normal',
                            color: 'black'}}
                            >Event Status
                    </BText>
                    <BText
                        style={{
                            fontSize: 15,
                            fontWeight: 'bold',
                            color: getStatusTextColor(selectedEvent.status) }}
                            >{selectedEvent.status}
                    </BText>
                </View> */}
                <View style={{ flexDirection: 'row', marginTop: 10 }}>
                <BText style={{ marginRight: 35 }}>Time Slot</BText>
                <Switch
                  trackColor={{ false: '#767577', true: '#d9d9d9' }}
                  thumbColor={withTimeSlot ? theme.colors.green : '#f4f4f4'}
                  onValueChange={toggleSwitchTimeSlot}
                  value={withTimeSlot}
                />
              </View>
            </FormContainer>
            <FormContainer width={windowWidth} style={{ marginTop: 10 }} title="Venue">
              <View style={{ flexDirection: 'row', marginTop: 10 }}>
                <BText style={{ marginRight: 35 }}>Online Event</BText>
                <Switch
                  trackColor={{ false: '#767577', true: '#d9d9d9' }}
                  thumbColor={isOnlineEvent ? theme.colors.green : '#f4f4f4'}
                  onValueChange={toggleSwitch}
                  value={isOnlineEvent}
                />
              </View>

              {!isOnlineEvent ? (
                <View style={{ flexDirection: 'column' }}>
                  <View style={{ flex: 1 }}>
                    <Input
                      label={'Address'}
                      id="address"
                      type="text"
                      value={selectedEvent?.address}
                      schemaContext={{ isEdit: true }}
                      ref={inputAddress}
                    />
                  </View>
                  <View style={styles.eventCateTypeContainer}>
                    <View style={{ flex: 1 }}>
                      <Input
                        label={'State'}
                        id="state"
                        type="select"
                        dataSource={states}
                        value={selectedEvent?.state}
                        onChange={(v: string) => setSelectedState(v)}
                        schemaContext={{ isEdit: true }}
                        ref={inputState}
                      />
                    </View>
                    <View style={{ padding: 10 }} />
                    <View style={{ flex: 1 }}>
                      <Input
                        label={'City'}
                        id="city"
                        type="select"
                        dataSource={cities}
                        value={selectedEvent?.city}
                        schemaContext={{ isEdit: true }}
                        ref={inputCity}
                      />
                    </View>
                  </View>
                  {/* <View style={{ flex: 1 }}>
                    <MapComponent lat={40.7128} lng={-74.0060} />
                  </View> */}
                </View>
              ) : (
                <Input
                  label={'Online Event Link'}
                  id="eventLink"
                  type="text"
                  value={selectedEvent ? selectedEvent.onlineEventLink : ''}
                  schemaContext={{ isEdit: true }}
                  ref={inputOnlinEventLink}
                />
              )}
            </FormContainer>
            {withTimeSlot ? (
            <FormContainer width={windowWidth} style={{ marginTop: 10 }} title="Date & Time">
              <FlatList
                data={data}
                renderItem={renderItem}
                keyExtractor={(item, index) => index.toString()}
              />
              
            </FormContainer>
            ) : (
              <View style={{ padding: 1 }} />
            )}
            <FormContainer width={windowWidth} style={{ marginTop: 10 }} title="Ticket">
              <View style={styles.eventTicketContainer}>
                <View style={{ flex: 1 }} pointerEvents={isReadOnly ? 'none' : 'auto'}>
                  <Input
                    label={'Price (RM)'}
                    id="ticketPrice"
                    type="number"
                    value={selectedEvent?.eventPrice}
                    schemaContext={{ isEdit: true }}
                    ref={inputTicketPrice}
                  />
                </View>
                <View style={{ padding: 10 }} />
                <View style={{ flex: 1 }} pointerEvents={isReadOnly ? 'none' : 'auto'}>
                  <Input
                    label={'Total Ticket'}
                    id="totalTicket"
                    type="number"
                    value={selectedEvent?.numberOfTickets}
                    schemaContext={{ isEdit: true }}
                    readOnly={isReadOnly}
                    ref={inputTotalTicket}
                  />
                </View>
                <View style={{ padding: 10 }} />
                <View style={{ flex: 1 }}>
                  <Input
                    label={'Ticket Sold'}
                    id="totalTicketSold"
                    type="number"
                    value={selectedEvent?.numberOfTicketsSold}
                    schemaContext={{ isEdit: true }}
                    readOnly={true}
                    ref={inputTotalTicketSold}
                  />
                </View>
              </View>
            </FormContainer>
            <FormContainer width={windowWidth} style={{ marginTop: 10 }} title="Type & Category">
              <View style={styles.eventCateTypeContainer}>
                <View style={{ flex: 1 }}>
                  <Input
                    label={'Category'}
                    id="category"
                    type="select"
                    dataSource={eventCates}
                    value={selectedEvent?.eventCategory?.name}
                    onChange={(v: string) => setSelectedCate(v)}
                    schemaContext={{ isEdit: true }}
                    ref={inputCategory}
                  />
                </View>
                <View style={{ padding: 10 }} />
                <View style={{ flex: 1 }}>
                  <Input
                    label={'Type'}
                    id="type"
                    type="select"
                    dataSource={eventTypes}
                    value={selectedEvent?.eventType?.name}
                    // onChange={(v: string) => setSelectedCate(v)}
                    schemaContext={{ isEdit: true }}
                    ref={inputCategory}
                  />
                </View>
              </View>
            </FormContainer>
            <FormContainer width={windowWidth} style={{ marginTop: 10 }} title="Terms and Conditons & Policy">
              <Input
                label={'Terms and Conditions'}
                id="tnc"
                value={selectedEvent?.termsAndConditions}
                // schemaObject={UserInputSchema}
                schemaContext={{ isEdit: true }}
                // readOnly={true}
                ref={inputTnc}
              />
              <Input
                label={'Policy'}
                id="policy"
                value={selectedEvent?.policy}
                // schemaObject={UserInputSchema}
                schemaContext={{ isEdit: true }}
                // readOnly={true}
                ref={inputPolicy}
              />
            </FormContainer>
          </View>
        </ScrollView>

        <Drawer
          id="event.publish"
          visible={showPublish}
          type={'onCancel'}
          onClose={() => setShowPublish(false)}
          onOK={() => handlePublish()}
          title={'Publish Event'}
          okLabel="Publish"
        >
          <BText>Are you confirm to publish this event?</BText>
        </Drawer>

        {showCalendar && (
          <TouchableWithoutFeedback>
            <View style={styles.calendarContainer}>
              <View style={styles.calendarView}>
                <Input
                  label={'Scheduled Date'}
                  id="scheduledDate"
                  type="date"
                  value={selectedEvent?.scheduledDate}
                  schemaContext={{ isEdit: true }}
                />
                <Input
                  label={'Scheduled Time'}
                  id="scheduledTime"
                  type="time"
                  value={selectedEvent?.scheduledDate}
                  schemaContext={{ isEdit: true }}
                />
                <ButtonContainer direction="horizontal" containerStyle={styles.scheduledDateButtonContainer}>
                  <Button onPress={() => handlePublish()}>Save</Button>
                  <Button onPress={() => setShowCalendar(false)}>Cancel</Button>
                </ButtonContainer>

                {/* <CalendarView
                  onDateSelected={handleDateSelected}
                  onSave={handleSave}
                  onCancel={() => handleCancel}
                /> */}
              </View>
            </View>
          </TouchableWithoutFeedback>
        )}

      </Page>
    </View>
  );
};

const styles = StyleSheet.create({
  eventContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eventContainerHeaderTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    paddingTop: 10,
    paddingBottom: 10,
  },
  eventDescriptionContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eventDateTimeContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  eventDateContainer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  eventTicketContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  eventCateTypeContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  stickyFooter: {
    zIndex: 1,
    width: 350,
    minWidth: 300,
    position: 'absolute',
    right: 10,
    paddingTop: 10,
    flexDirection: 'row',
  },
  verticalFlex: {
    flexDirection: 'column',
    marginHorizontal: 'auto',
  },
  buttonContainer: {
    alignSelf: 'stretch',
    marginTop: 20,
  },
  squareContainer: {
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'row',
    backgroundColor: '#40784e',
    borderRadius: 10,
    alignSelf: 'baseline',
    padding: 10,
  },
  squareTitle: {
    fontSize: 11,
    color: '#a8a8a8',
  },
  squareText: {
    fontSize: 14,
    alignItems: 'flex-end',
    paddingTop: 5,
    color: 'white',
  },
  optionsList: {
    position: 'absolute',
    top: '100%',
    right: 0,
    backgroundColor: 'white',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    padding: 10,
    borderRadius: 5,
    zIndex: 2,
  },
  optionItem: {
    padding: 5,
    borderColor: 'gray',
  },
  calendarContainer: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    width: '100%',
    height: '100%',
    flex: 1,
    justifyContent: 'center', // Align children vertically center
    alignItems: 'center', // Align children horizontally center
  },
  calendarView: {
    position: 'relative',
    width: 'auto', // Adjust the width as needed
    backgroundColor: themeConfig.colors.white,
    borderRadius: themeConfig.settings.borderRadius,
    elevation: 4,
    alignItems: 'baseline',
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingVertical: 50,
  },
  pressContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 2,
  },
  scheduledDateButtonContainer: {
    zIndex: 1,
    width: '100%',
    flexDirection: 'row',
  },
  buttonIcon: {
    position: 'relative',
    width: '100%',
    marginBottom: '0px',
    marginRight: '100px',
    marginLeft: '100px',
    marginTop: '30px',
    maxWidth: '50%',
  },
});
